import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  HttpMethod__toString_impl_hhk5hkow7sfhij4zpj as HttpMethod__toString_impl_hhk5hk,
  Companion_getInstancel4ymxmn2l08f as Companion_getInstance,
} from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import {
  HttpMethod_HEAD_getInstance1otx4m6279kqg as HttpMethod_HEAD_getInstance,
  HttpMethod_DELETE_getInstance3fu12lv9nt4sc as HttpMethod_DELETE_getInstance,
  HttpMethod_PATCH_getInstance296lcybjyjs1x as HttpMethod_PATCH_getInstance,
  HttpMethod_POST_getInstance3pqm6v4mk6ac0 as HttpMethod_POST_getInstance,
  HttpMethod_PUT_getInstance2nakgsizsajmw as HttpMethod_PUT_getInstance,
  HttpMethod_GET_getInstance1esunrp6hgoe5 as HttpMethod_GET_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BufferOverflow_SUSPEND_getInstance1ucmryz5dsuc2 as BufferOverflow_SUSPEND_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import { onSubscription3iwvbdmbwg7iq as onSubscription } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Share.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { BaseResourceUse29ny90pfhtji3 as BaseResourceUse } from '../db/utils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { take9j4462mea726 as take } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance27cl4xxdoduaj as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import { Companion_getInstance3bjjjd8igr9ok as Companion_getInstance_0 } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { distinctUntilChanged3tb35h4hwds5o as distinctUntilChanged } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Distinct.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
import { launchInn279ped9kwez as launchIn } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toTypedWebSocket(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof LightningServerWebSocket()) {
    tmp = _this__u8e3s4.wraps_1;
  } else {
    tmp = new (ReactiveClientWebSocket())(_this__u8e3s4);
  }
  return tmp;
}
function get_kiteUi(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance().GET_1) {
    tmp = HttpMethod_GET_getInstance();
  } else if (_this__u8e3s4 === Companion_getInstance().PUT_1) {
    tmp = HttpMethod_PUT_getInstance();
  } else if (_this__u8e3s4 === Companion_getInstance().POST_1) {
    tmp = HttpMethod_POST_getInstance();
  } else if (_this__u8e3s4 === Companion_getInstance().PATCH_1) {
    tmp = HttpMethod_PATCH_getInstance();
  } else if (_this__u8e3s4 === Companion_getInstance().DELETE_1) {
    tmp = HttpMethod_DELETE_getInstance();
  } else if (_this__u8e3s4 === Companion_getInstance().HEAD_1) {
    tmp = HttpMethod_HEAD_getInstance();
  } else {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Unsupported HttpMethod: ' + HttpMethod__toString_impl_hhk5hk(_this__u8e3s4));
  }
  return tmp;
}
function typed(_this__u8e3s4, json, send, receive) {
  return new (SerializerSocket())(_this__u8e3s4, json, send, receive);
}
function toSharedFlow(_this__u8e3s4, context, replay, extraBufferCapacity, onBufferOverflow) {
  context = context === VOID ? Dispatchers_getInstance().Unconfined_1 : context;
  replay = replay === VOID ? 1 : replay;
  extraBufferCapacity = extraBufferCapacity === VOID ? 0 : extraBufferCapacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
  var tmp$ret$0 = new (toSharedFlow$$inlined$CoroutineExceptionHandler$1())();
  var fullContext = context.plus_s13ygv_k$(tmp$ret$0);
  var listener = {_v: null};
  var flow = MutableSharedFlow(replay, extraBufferCapacity, onBufferOverflow);
  return onSubscription(flow, toSharedFlow$slambda(listener, fullContext, flow, _this__u8e3s4));
}
function toClientWebSocket(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ReactiveClientWebSocket()) {
    tmp = _this__u8e3s4.wraps_1;
  } else {
    tmp = new (LightningServerWebSocket())(_this__u8e3s4);
  }
  return tmp;
}
var LightningServerWebSocketClass;
function LightningServerWebSocket() {
  if (LightningServerWebSocketClass === VOID) {
    class $ {
      constructor(wraps) {
        this.wraps_1 = wraps;
        var tmp = this;
        tmp.connected$delegate_1 = lazy(() => toSharedFlow(this.wraps_1.get_connected_12bogw_k$()));
        this.endUse_1 = null;
      }
      connect_ivqcka_k$() {
        if (this.endUse_1 == null)
          this.endUse_1 = this.wraps_1.beginUse_omrbby_k$();
      }
      close_a2oca2_k$(code, reason) {
        var tmp0_safe_receiver = this.endUse_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.endUse_1 = null;
        this.wraps_1.close_a2oca2_k$(code, reason);
      }
      onClose_nz13c7_k$(action) {
        return this.wraps_1.onClose_nz13c7_k$(action);
      }
      onOpen_i39mgf_k$(action) {
        return this.wraps_1.onOpen_i39mgf_k$(action);
      }
      onMessage_68111k_k$(action) {
        return this.wraps_1.onMessage_68111k_k$(action);
      }
      send_lirmaz_k$(data) {
        return this.wraps_1.send_lirmaz_k$(data);
      }
    }
    initMetadataForClass($, 'LightningServerWebSocket');
    LightningServerWebSocketClass = $;
  }
  return LightningServerWebSocketClass;
}
var ReactiveClientWebSocketClass;
function ReactiveClientWebSocket() {
  if (ReactiveClientWebSocketClass === VOID) {
    class $ extends BaseResourceUse() {
      constructor(wraps) {
        super();
        this.wraps_1 = wraps;
        this._connected_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.connected_1 = this._connected_1;
        this.wraps_1.onOpen_i39mgf_k$(() => {
          this._connected_1.set_value_v1vabv_k$(true);
          return Unit_instance;
        });
        this.wraps_1.onClose_nz13c7_k$((it) => {
          this._connected_1.set_value_v1vabv_k$(false);
          return Unit_instance;
        });
      }
      get_connected_12bogw_k$() {
        return this.connected_1;
      }
      activate_yijg9v_k$() {
        this.wraps_1.connect_ivqcka_k$();
      }
      deactivate_pmdz1g_k$() {
        this.wraps_1.close_a2oca2_k$(1000, 'Closing because no one is listening');
      }
      close_a2oca2_k$(code, reason) {
        return this.wraps_1.close_a2oca2_k$(code, reason);
      }
      onClose_nz13c7_k$(action) {
        return this.wraps_1.onClose_nz13c7_k$(action);
      }
      onMessage_68111k_k$(action) {
        return this.wraps_1.onMessage_68111k_k$(action);
      }
      onOpen_i39mgf_k$(action) {
        return this.wraps_1.onOpen_i39mgf_k$(action);
      }
      send_lirmaz_k$(data) {
        return this.wraps_1.send_lirmaz_k$(data);
      }
    }
    initMetadataForClass($, 'ReactiveClientWebSocket');
    ReactiveClientWebSocketClass = $;
  }
  return ReactiveClientWebSocketClass;
}
var SerializerSocketClass;
function SerializerSocket() {
  if (SerializerSocketClass === VOID) {
    class $ {
      constructor(wraps, json, send, receive) {
        this.wraps_1 = wraps;
        this.json_1 = json;
        this.send_1 = send;
        this.receive_1 = receive;
      }
      connect_ivqcka_k$() {
        return this.wraps_1.connect_ivqcka_k$();
      }
      close_a2oca2_k$(code, reason) {
        return this.wraps_1.close_a2oca2_k$(code, reason);
      }
      onOpen_i39mgf_k$(action) {
        return this.wraps_1.onOpen_i39mgf_k$(action);
      }
      onClose_nz13c7_k$(action) {
        return this.wraps_1.onClose_nz13c7_k$(action);
      }
      onMessage_68111k_k$(action) {
        this.wraps_1.onMessage_68111k_k$((it) => {
          var tmp;
          try {
            tmp = action(this.json_1.decodeFromString_jwu9sq_k$(this.receive_1, it));
          } catch ($p) {
            var tmp_0;
            if ($p instanceof CancellationException()) {
              var e = $p;
              tmp_0 = Unit_instance;
            } else {
              if ($p instanceof Exception()) {
                var e_0 = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to decode message; expected a ' + this.receive_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + " but got '" + take(it, 150) + "'", e_0));
                tmp_0 = Unit_instance;
              } else {
                throw $p;
              }
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
      }
      send_lirmaz_k$(data) {
        return this.wraps_1.send_lirmaz_k$(this.json_1.encodeToString_k0apqx_k$(this.send_1, data));
      }
    }
    initMetadataForClass($, 'SerializerSocket');
    SerializerSocketClass = $;
  }
  return SerializerSocketClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $_0 {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      *emit_t92u1f_k$(value, $completion) {
        return yield* $(this.function_1(value, $completion), $completion);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $_0;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
function toSharedFlow$startListening$o$collect$slambda($$this$unsafeFlow) {
  return constructCallableReference((value, $completion) => orPromise($completion, function *($completion) {
    var tmp0 = $$this$unsafeFlow;
    var tmp$ret$1 = value > 0;
    yield* tmp0.emit_t92u1f_k$(tmp$ret$1, $completion);
    return Unit_instance;
  }), 1);
}
var toSharedFlow$startListening$$inlined$map$1Class;
function toSharedFlow$startListening$$inlined$map$1() {
  if (toSharedFlow$startListening$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this) {
        this.$this_1 = $this;
      }
      *collect_ooju95_k$(collector, $completion) {
        var tmp = toSharedFlow$startListening$o$collect$slambda(collector);
        yield* this.$this_1.collect_aksokr_k$(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      collect_aksokr_k$(collector, $completion) {
        return this.collect_ooju95_k$(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    toSharedFlow$startListening$$inlined$map$1Class = $;
  }
  return toSharedFlow$startListening$$inlined$map$1Class;
}
function toSharedFlow$startListening$slambda($listener, $this_toSharedFlow, $flow, $this_startListening) {
  return constructCallableReference((isActive, $completion) => orPromise($completion, function *($completion) {
    if (isActive) {
      $listener._v = $this_toSharedFlow.addListener_6y9mct_k$(() => {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = $this_toSharedFlow.get_state_wc71uu_k$();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp = null;
        } else {
          if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
            tmp = null;
          } else {
            if (tmp0_subject instanceof InternalReactiveThrownException()) {
              _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
              tmp = null;
            } else {
              if (tmp0_subject instanceof InternalReactiveWrapper()) {
                var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
                tmp = $flow.tryEmit_ru0jrz_k$(it);
              } else {
                var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
                tmp = $flow.tryEmit_ru0jrz_k$(it_0);
              }
            }
          }
        }
        return Unit_instance;
      });
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = $this_toSharedFlow.get_state_wc71uu_k$();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        tmp = null;
      } else {
        if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
            tmp = null;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var it = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
              tmp = $flow.tryEmit_ru0jrz_k$(it);
            } else {
              var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
              tmp = $flow.tryEmit_ru0jrz_k$(it_0);
            }
          }
        }
      }
    } else {
      var tmp0_safe_receiver = $listener._v;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      $listener._v = null;
      cancel($this_startListening);
    }
    return Unit_instance;
  }), 1);
}
var toSharedFlow$$inlined$CoroutineExceptionHandler$1Class;
function toSharedFlow$$inlined$CoroutineExceptionHandler$1() {
  if (toSharedFlow$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      handleException_e679jj_k$(context, exception) {
        if (!(exception instanceof CancellationException())) {
          Companion_getInstance_0().reportException_1(exception);
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Element()]);
    toSharedFlow$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return toSharedFlow$$inlined$CoroutineExceptionHandler$1Class;
}
function toSharedFlow$startListening(_this__u8e3s4, flow, listener, $this_toSharedFlow) {
  // Inline function 'kotlinx.coroutines.flow.map' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = flow.get_subscriptionCount_9h9j93_k$();
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp$ret$0 = new (toSharedFlow$startListening$$inlined$map$1())(this_0);
  var tmp = distinctUntilChanged(tmp$ret$0);
  launchIn(onEach(tmp, toSharedFlow$startListening$slambda(listener, $this_toSharedFlow, flow, _this__u8e3s4)), _this__u8e3s4);
}
function toSharedFlow$slambda($listener, $fullContext, $flow, $this_toSharedFlow) {
  return constructCallableReference(($this$onSubscription, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($listener._v == null) {
      toSharedFlow$startListening(CoroutineScope($fullContext), $flow, $listener, $this_toSharedFlow);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  get_kiteUi as get_kiteUi2m7u81n0o8zpz,
  toClientWebSocket as toClientWebSocketu5uqzcygbetr,
  toSharedFlow as toSharedFlow13chr9mav6h4g,
  toTypedWebSocket as toTypedWebSocket14iamnuoa79fq,
  typed as typed22kjp7k0ibsl8,
};
//endregion

//# sourceMappingURL=adapt.mjs.map
